import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import React from 'react';
import Pricing from "./pages/pricing";
import Landing from "./pages/landing";
import PublishedLanding from "./pages/published-landing";
import AboutUs from "./pages/about_us";
import ContactUs from "./pages/contact_us";
import FeatureReview from "./pages/feature";
import NotFoundPage from "./pages/not-found";
import BlogPage from "./pages/blog";
import CareerView from "./pages/join_us";
import LandingHomes from "./pages/marketing/landing_marketing";
import AllFeatures from "./components/home/full-features";
import ScrollToTop from "./components/scroll_to_top";
import LandingSearch from "./pages/marketing_search/landing_search";

import ProjectPublish from "./pages/publish/ProjectPublish";
import MilestoneView from "./pages/publish/milestone";
import SolutionPage from "./pages/solutions/SolutionPage";
import NgoPage from "./pages/solutions/NgoPage";
import ContractorsPage from "./pages/solutions/ContractorsPage";
import BanksPage from "./pages/solutions/BanksPage";
import BorderlessPage from "./pages/solutions/BorderlessPage";
import BorderlessPortfolioPage from "./pages/solutions/BorderlessPortfolioPage";
import DiasporaPage from "./pages/solutions/DiasporaPage";
import GreenBuildingPage from "./pages/solutions/GreenBuildingPage";
import { ProductFlowProvider } from "./utils/product-flow";
import { PUBLISHED_ENABLED, MANAGEMENT_ENABLED } from "./utils/site-mode";
import FaqPage from "./pages/faq";


function App() {
  return (
    <Router>
      <ProductFlowProvider>
      <ScrollToTop />
      <Routes>
        {/* Home: published landing normally; PM landing in management-only builds */}
        <Route path="/" element={PUBLISHED_ENABLED ? <PublishedLanding /> : <Landing />} />

        {/* Project Management product */}
        {MANAGEMENT_ENABLED ? (
          <>
            <Route path="/products/project-management" element={<Landing />} />
            <Route path="/platform/features" element={<AllFeatures />} />
          </>
        ) : (
          <>
            <Route path="/products/project-management" element={<Navigate to="/" replace />} />
            <Route path="/platform/features" element={<Navigate to="/" replace />} />
          </>
        )}

        {/* Published Projects product */}
        {PUBLISHED_ENABLED ? (
          <>
            <Route path="/solutions/banks" element={<BanksPage />} />
            <Route path="/solutions/borderless" element={<BorderlessPage />} />
            <Route path="/solutions/borderless/portfolio" element={<BorderlessPortfolioPage />} />
            <Route path="/solutions/borderless/portfolio/:registrationNo" element={<BorderlessPortfolioPage />} />
            <Route path="/architect" element={<BorderlessPortfolioPage />} />
            <Route path="/architect/:registrationNo" element={<BorderlessPortfolioPage />} />
            <Route path="/solutions/ngos" element={<NgoPage />} />
            <Route path="/solutions/diaspora" element={<DiasporaPage />} />
            <Route path="/solutions/contractors" element={<ContractorsPage />} />
            <Route path="/solutions/green-building" element={<GreenBuildingPage />} />
            <Route path="/solutions/:slug" element={<SolutionPage />} />
          </>
        ) : (
          <Route path="/solutions/*" element={<Navigate to="/" replace />} />
        )}

        {/* Common */}
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/careers" element={<CareerView />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/feature" element={<FeatureReview />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="/diaspora/homes" element={<LandingHomes />} />
        <Route path="/project/search" element={<LandingSearch />} />
        <Route path="/search" element={<LandingSearch initialDrawerOpen={true} />} />

        <Route path="/publish/:id" element={<ProjectPublish />} />
        <Route path="/publish/milestone" element={<MilestoneView />} />

      </Routes>
      </ProductFlowProvider>
    </Router>
  );
}

export default App;
